// Factory Job Card - Checkpoint Visibility Rules

export const CHECKPOINT_VISIBILITY_RULES = [
    {
        dependsOn: 7, // Gas Found
        hide: [8, 9, 10],
        showWhen: (cp) => cp.resultVal.toLowerCase() === "yes",
    },
    {
        dependsOn: 16, // Slug Found
        hide: [17],
        showWhen: (cp) => cp.resultVal.toLowerCase() === "yes",
    },
    {
        dependsOn: 18, // Water Found
        hide: [19],
        showWhen: (cp) => cp.resultVal.toLowerCase() === "yes",
    },
    {
        dependsOn: 3, // Color Check
        hide: [4, 5, 24],
        showWhen: (cp) => cp.resultVal.toLowerCase() === "not ok",
    },
    {
        dependsOn: 6, // Sand Blasting Check
        hide: [23],
        showWhen: (cp) => cp.resultVal.toLowerCase() === "yes",
    },
];

export const shouldRenderCheckpoint = (
    checkpointId,
    updatedCheckPoints,
) => {
    for (const rule of CHECKPOINT_VISIBILITY_RULES) {
        if (!rule.hide.includes(checkpointId)) continue;

        const dependency = updatedCheckPoints?.find(
            (cp) => cp.checkpointId === rule.dependsOn,
        );

        if (!dependency) return false;

        if (!rule.showWhen(dependency)) return false;
    }

    return true;
};
